// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2FAGb","colMin":"styles_colMin__12Xbe","colCheckbox":"styles_colCheckbox__3SkgM"};